var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 11.6875H6.5625",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 12.9375V10.4375",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09963 6.29375C5.03713 6.2875 4.96213 6.2875 4.89338 6.29375C3.40588 6.24375 2.22463 5.025 2.22463 3.525C2.21838 1.99375 3.46213 0.75 4.99338 0.75C6.52463 0.75 7.76838 1.99375 7.76838 3.525C7.76838 5.025 6.58088 6.24375 5.09963 6.29375Z",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99365 13.1312C3.85615 13.1312 2.7249 12.8437 1.8624 12.2687C0.349902 11.2562 0.349902 9.60618 1.8624 8.59993C3.58115 7.44993 6.3999 7.44993 8.11865 8.59993",
    stroke: "#758CA5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.164101c171eeaa4a436dad09e978292e.svg";
export { ForwardRef as ReactComponent };